import { useEffect, useState } from 'react'
import { api } from '../../api'

/**
 * Carte « Versement de mes ventes » (sequestre ADR-058 §3, decision Enzo
 * 9 juil) — le producteur choisit le sort de sa part apres la fenetre
 * d'ajustement : AUTO (virement sans action, defaut) ou WALLET (garder en
 * credit utilisable dans Lyannaj, retrait quand il veut).
 * Vit dans le WALLET (retour Enzo 10 juil : c'est la que se gere l'argent),
 * autonome : lit la preference via getMe, sauvegarde optimiste avec rollback.
 */
const TEAL = 'rgb(var(--c-teal))'
const VERT = 'rgb(var(--c-green))'

function VersementModeCard({ onToast }) {
  const [mode, setMode] = useState(null)
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    api.producer.getMe()
      .then((org) => setMode(org?.versementMode || 'AUTO'))
      .catch(() => setMode('AUTO'))
  }, [])

  const choisir = async (m) => {
    if (m === mode || saving) return
    const precedent = mode
    setSaving(true)
    setMode(m) // optimiste, rollback si echec
    try {
      await api.producer.setVersementMode(m)
      onToast?.(m === 'WALLET' ? 'Tes ventes resteront sur ton wallet ✓' : 'Versement automatique activé ✓')
    } catch {
      setMode(precedent)
      onToast?.('La préférence de versement n’a pas pu être enregistrée — réessaie.')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="glass-surface rounded-[20px] mb-4 p-4">
      <p className="text-[10.5px] font-bold uppercase mb-1" style={{ letterSpacing: 1.5, color: TEAL }}>
        Versement de mes ventes
      </p>
      <p className="text-xs leading-relaxed mb-3 text-ink/60">
        Après la fenêtre d'ajustement d'une commande Paniers, votre part vous revient. Choisissez comment :
      </p>
      <div className="flex flex-col gap-2">
        {[
          {
            k: 'AUTO', l: 'Versement automatique', suffixe: ' · par défaut',
            d: 'Votre argent part vers votre compte bancaire sans action de votre part.',
          },
          {
            k: 'WALLET', l: 'Garder sur mon wallet', suffixe: '',
            d: 'Votre solde reste utilisable dans Lyannaj (payer votre commission marché…) — vous retirez quand vous voulez.',
          },
        ].map((m) => {
          const on = mode === m.k
          return (
            <button
              key={m.k}
              onClick={() => choisir(m.k)}
              disabled={saving || mode == null}
              className="rounded-2xl flex items-center gap-3 text-left"
              style={{
                padding: '13px 14px',
                border: on ? `1.5px solid ${TEAL}` : '1px solid rgba(7,62,61,0.1)',
                background: on ? 'rgba(20,184,166,0.08)' : 'rgba(255,255,255,0.5)',
                opacity: mode == null ? 0.6 : 1,
              }}
            >
              <div className="flex-1 min-w-0">
                <p className="text-sm font-bold" style={{ color: VERT }}>{m.l}{m.suffixe}</p>
                <p className="text-[11px] leading-snug mt-0.5 text-ink/55">{m.d}</p>
              </div>
              <span
                className="w-[22px] h-[22px] rounded-full flex-shrink-0 flex items-center justify-center text-white text-[13px] font-extrabold"
                style={{ border: on ? 'none' : '2px solid rgba(7,62,61,0.25)', background: on ? TEAL : 'transparent' }}
              >
                {on ? '✓' : ''}
              </span>
            </button>
          )
        })}
      </div>
      <p className="text-[10.5px] leading-relaxed mt-2.5 text-ink/45">
        Le retrait vers votre banque nécessite une inscription Stripe complète (vérification d'identité).
      </p>
    </div>
  )
}

export default VersementModeCard
